"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var scheme;
(function (scheme) {
    /// <summary>
    /// The scheme is unknown.
    /// </summary>
    scheme[scheme["Unknown"] = 0] = "Unknown";
    /// <summary>
    /// GS1 encoding.
    /// </summary>
    scheme[scheme["Gs1"] = 1] = "Gs1";
    /// <summary>
    /// IFA encoding for EMVS.
    /// </summary>
    scheme[scheme["Ifa"] = 2] = "Ifa";
})(scheme = exports.scheme || (exports.scheme = {}));
var PackIdentifier = /** @class */ (function () {
    function PackIdentifier(pack) {
        var _this = this;
        this.key = function () {
            return _this.productCode + _this.serialNumber + _this.batchIdentifier + _this.expiry;
        };
        this.getFormatExpiryDate = function () {
            var formattedDate = "";
            var yearLastTwoDigits = _this.expiry.slice(0, 2);
            var currentYear = new Number(new Date().getFullYear().toString().slice(2, 4)).valueOf();
            var yearDif = new Number(yearLastTwoDigits).valueOf() - currentYear;
            var yearFirstTwoDigits = "";
            if (yearDif >= 51) {
                yearFirstTwoDigits = (currentYear - 1).toString();
            }
            else if (yearDif <= -50) {
                yearFirstTwoDigits = (currentYear + 1).toString();
            }
            else {
                yearFirstTwoDigits = currentYear.toString();
            }
            formattedDate += yearFirstTwoDigits + yearLastTwoDigits;
            var m = _this.expiry.slice(2, 4);
            formattedDate += "/" + m;
            var d = _this.expiry.slice(4, 6);
            if (d !== "00") {
                formattedDate += "/" + d;
            }
            return formattedDate;
        };
        if (pack !== undefined) {
        }
        this.productCode = pack !== undefined ? pack.productCode : "";
        this.serialNumber = pack !== undefined ? pack.serialNumber : "";
        this.batchIdentifier = pack !== undefined ? pack.batchIdentifier : "";
        this.expiry = pack !== undefined ? pack.expiry : "";
        this.scheme = pack !== undefined ? pack.scheme : 0;
        this.issuingAgencyCompanyPrefix = pack !== undefined ? pack.issuingAgencyCompanyPrefix : 0;
        this.validSymbology = pack !== undefined ? pack.validSymbology : 0;
        this.submit = pack !== undefined ? pack.submit : false;
        this.isValid = pack !== undefined ? pack.isValid : false;
        this.exceptions = pack !== undefined ? pack.exceptions : [];
        this.parseExceptions = pack !== undefined ? pack.parseExceptions : [];
        this.records = pack !== undefined ? pack.records : [];
    }
    PackIdentifier.fromPromise = function (json) {
        return json.then(function (pack) {
            return new PackIdentifier(pack);
        });
    };
    return PackIdentifier;
}());
exports.PackIdentifier = PackIdentifier;
//# sourceMappingURL=PackIdentifier.js.map